export const UserWalletData = [
	{
		"id":1,
		"refid": "#1001",
		"transactionfor": "Self Deposit Paypal",
		"date": "15 Sep 2023, 09:00 AM",
		"total": "+ $300",
		"status": "Completed",
		
	},
	{
		"id":2,
		"refid": "#1002",
		"transactionfor": "Audi A3 2019 new",
		"date": "23 Oct 2023, 12:00 PM",
		"total": "- $500",
		"status": "Completed",
		
	},
	{
		"id":3,
		"refid": "#1003",
		"transactionfor": "Self Deposit Stripe",
		"date": "02 Nov 2023, 10:30 AM",
		"total": "+ $600",
		"status": "Completed",
		
	},
	{
		"id":4,
		"refid": "#1004",
		"transactionfor": "Audi A3 2020 new",
		"date": "18 Dec 2023, 02:30 PM",
		"total": "+ $1500",
		"status": "Pending",
		
	},
	{
		"id":5,
		"refid": "#1005",
		"transactionfor": "Self Deposit Stripe",
		"date": "05 Jan 2024, 08:00 AM",
		"total": "- $450",
		"status": "Failed",
		
	},
	{
		"id":6,
		"refid": "#1006",
		"transactionfor": "Self Deposit Paypal",
		"date": "20 Feb 2024, 11:30 PM",
		"total": "+ $1000",
		"status": "Completed",
		
	}
]